export default "__VITE_ASSET__Bj2bVz_v__"